import {
  AddCampaignPinnedObjectLinkClients,
  AddPinnedObjectRelationshipClients,
  RemovePinnedObjectRelationshipClients,
} from '@ms/yammer-graphql';

import {
  FileReference,
  FileSchemas,
  FileWithGroupNameWithType,
  ImageFileReference,
  ImageWithType,
  SharePointFileLinkWithType,
  VideoFileReference,
  VideoWithType,
  WebImageReference,
  WebLinkReference,
  WebLinkSchemas,
  WebLinkWithType,
  WebVideoReference,
} from '../../state/types';

export type PinnedObjectReference =
  | FileReference
  | ImageFileReference
  | VideoFileReference
  | WebLinkReference
  | WebImageReference
  | WebVideoReference;

export type PinnedObjectReferenceSchema = WebLinkSchemas | FileSchemas;

export type PinnedObjectType =
  | FileWithGroupNameWithType
  | ImageWithType
  | VideoWithType
  | WebLinkWithType
  | SharePointFileLinkWithType;
export type PinnedObjectEdge = PinnedObjectType & { readonly edgeId: string; readonly pinnedLinkTitle?: string };

export interface RemovePinnedObjectRelationshipResponse {
  readonly data: RemovePinnedObjectRelationshipClients;
}

export interface AddPinnedObjectRelationshipResponse {
  readonly data: AddPinnedObjectRelationshipClients;
}

export interface AddCampaignPinnedObjectLinkResponse {
  readonly data: AddCampaignPinnedObjectLinkClients;
}

export const pendingPinnedObjectEdgeId = 'pending';

export enum PinnedObjectSourceType {
  Group = 'group',
  Campaign = 'campaign',
}
